// src/App.js
import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import "./styles/App.css"; // Imports global styles
import AuthProvider from "./context/AuthContext";
import { SocketProvider } from "./context/SocketContext";
import AppRoutes from "./routes/AppRoutes";
import Navbar from "./components/layout/Navbar";
import Footer from "./components/layout/Footer";
import useScrollEffect from "./hooks/useScrollEffect";
import ToastManager from "./components/common/ToastManager"

function App() {
  const { contentRef } = useScrollEffect();

  return (
    <Router>
      <AuthProvider>
        <SocketProvider>
          <ToastManager />
          <div className="app-container">
            <Navbar />
            <main className="app-content">
              <div className="content-wrapper" ref={contentRef}>
                <AppRoutes />
              </div>
            </main>
            <Footer />
          </div>
        </SocketProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;